export type CalendarCell = { date?: string; inMonth: boolean };

/** `monthYm` は YYYY-MM。UTC 暦で全日セルを並べ、月外は muted 用に inMonth:false */
export function buildMonthCalendarCells(monthYm: string): CalendarCell[] {
  if (!/^\d{4}-\d{2}$/.test(monthYm)) return [];
  const [yy, mm] = monthYm.split("-").map(Number);
  const first = new Date(Date.UTC(yy, mm - 1, 1));
  const startWeekday = first.getUTCDay();
  const last = new Date(Date.UTC(yy, mm, 0));
  const daysInMonth = last.getUTCDate();
  const cells: CalendarCell[] = [];
  for (let i = 0; i < startWeekday; i++) cells.push({ inMonth: false });
  for (let d = 1; d <= daysInMonth; d++) {
    const ds = `${yy}-${String(mm).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
    cells.push({ date: ds, inMonth: true });
  }
  while (cells.length % 7 !== 0) cells.push({ inMonth: false });
  return cells;
}

export function shiftYearMonth(ym: string, delta: number): string {
  const [y, m] = ym.split("-").map(Number);
  const u = Date.UTC(y, m - 1 + delta, 1);
  const yy = new Date(u).getUTCFullYear();
  const mm = String(new Date(u).getUTCMonth() + 1).padStart(2, "0");
  return `${yy}-${mm}`;
}
